export default {"src":"/_next/static/media/wallet-connect.35f980b5.svg","height":332,"width":480,"blurWidth":0,"blurHeight":0};